import script from "./summary-statement-step2.vue?vue&type=script&setup=true&lang=ts"
export * from "./summary-statement-step2.vue?vue&type=script&setup=true&lang=ts"

import "./summary-statement-step2.vue?vue&type=style&index=0&id=5c94d944&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c94d944"]])

export default __exports__